const state = {
  journies: {
    gasToGas: [
      'address', 'compareFuel', 'gasCurrentPayMethod', 'gasSupplierId.gasTariff.gasTariffValidToDate',
      'gasUsage', 'newTariffPaymentMethod'
    ],
    electricityToElectricity: [
      'address', 'compareFuel', 'isEconomy7', 'electricityCurrentPayMethod', 'electricitySupplierId.electricityTariff.electricityTariffValidToDate',
      'electricityUsage', 'economy7Percentage', 'newTariffPaymentMethod'
    ],
    dualConsolidatedToDualConsolidated: [
      'address', 'compareFuel', 'isEconomy7', 'currentPayMethod', 'supplierId.tariff.tariffValidToDate',
      'gasUsage.electricityUsage', 'economy7Percentage', 'newTariffPaymentMethod'
    ],
    dualDistinctToDualConsolidated: [
      'address', 'compareFuel', 'isEconomy7', 'gasCurrentPayMethod', 'gasSupplierId.gasTariff.gasTariffValidToDate',
      'gasUsage', 'electricityCurrentPayMethod', 'electricitySupplierId.electricityTariff.electricityTariffValidToDate',
      'electricityUsage', 'economy7Percentage', 'newTariffPaymentMethod'

    ]
    // dualConsolidatedToDualConsolidated: [
    //   'address', 'compareFuel', 'sameSupplier', 'isEconomy7', 'currentPayMethod', 'supplierId',
    //   'tariff.tariffValidToDate', 'gasUsage.electricityUsage', 'economy7Percentage', 'newTariffPaymentMethod'
    // ],
    // dualDistinctToDualConsolidated: [
    //   'address', 'compareFuel', 'sameSupplier', 'isEconomy7', 'gasCurrentPayMethod', 'gasSupplierId',
    //   'gasTariff.gasTariffValidToDate', 'gasUsage', 'electricityCurrentPayMethod', 'electricitySupplierId',
    //   'electricityTariff.electricityTariffValidToDate', 'electricityUsage', 'economy7Percentage', 'newTariffPaymentMethod'
    // ]
  }
};

const getters = {
  journey: (state, getters, rootState, rootGetters) => {
    const { currentPayMethod, electricityCurrentPayMethod, gasCurrentPayMethod } = rootState.quote;
    const isGasPrepayment = gasCurrentPayMethod === 'prePaymentMeter';
    const isElectricityPrepayment = electricityCurrentPayMethod === 'prePaymentMeter';
    const isPrepayment = currentPayMethod === 'prePaymentMeter';
    const quoteType = rootGetters['quote/quoteType'];
    const is02Meter = rootGetters['quote/is02Meter'];
    const noMpan = rootGetters['quote/noMpan'];
    let journey = state.journies[quoteType];

    if (!is02Meter) {
      journey = removeFromArray(journey, ['economy7Percentage']);
    }

    if (quoteType != 'gasToGas' && !noMpan) {
      journey = removeFromArray(journey, ['isEconomy7']);
    }
    // Gas-only + Dual consolidated: match standard dual (hide Economy 7 when no MPAN)
    if (quoteType == 'dualConsolidatedToDualConsolidated' && noMpan) {
      const parts = rootState.quote.address && rootState.quote.address.parts;
      if (parts) {
        const gasdetails = (parts.gasdetails || []).find(({ isDomestic }) => isDomestic);
        const elecdetails = (parts.elecdetails || []).find(({ isDomestic }) => isDomestic);
        if (gasdetails && !elecdetails) {
          journey = removeFromArray(journey, ['isEconomy7']);
        }
      }
    }

    if (quoteType == 'gasToGas' && isGasPrepayment) {
      journey = removeFromArray(journey, ['newTariffPaymentMethod']);
    }

    if (quoteType == 'electricityToElectricity' && isElectricityPrepayment) {
      journey = removeFromArray(journey, ['newTariffPaymentMethod']);
    }

    if (quoteType == 'dualConsolidatedToDualConsolidated' && isPrepayment) {
      journey = removeFromArray(journey, ['newTariffPaymentMethod']);
    }

    if (quoteType == 'dualDistinctToDualConsolidated' && (isElectricityPrepayment || isGasPrepayment)) {
      journey = removeFromArray(journey, ['newTariffPaymentMethod']);
    }

    return journey;
  }
};

const actions = {};

const mutations = {
  updateState (state, { prop, value }) {
    state[prop] = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

function removeFromArray (array, removeList) {
  return array.filter(item => removeList.indexOf(item) === -1);
}
